/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Echart from './Echart';
import store from "../../../components/stores/Store";



const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
  paper: {
    padding: '8px',
    textAlign: 'center',
  },
};
class Statistics extends Component {
  constructor() {
    super();
  }

  async componentDidMount() {
    document.title = "安置房住户统计";
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          安置房住户统计
        </Typography>
        <Echart />
      </div>
    );
  }
}

const StatisticsObserver = observer(Statistics);

StatisticsObserver.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StatisticsObserver);
